import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        checkbox: {
            paddingTop: '0 !important',
        },
        container: {
            display: 'flex',
            alignItems: 'center',
            height: '100%',
        },
    }
})

export default useStyles
